import { createStore } from '@stencil/store'
import { ConfigResponse } from '@zoom/appssdk'
import { logWithBadge } from 'src/utils/logging'

import { SDKMeetingInformation } from './types'
import { getSDKMeetingInformation } from './utils'

export const ZoomAppStore = createStore({
  configResponse: null as ConfigResponse,
  meetingInformation: null as SDKMeetingInformation,
  inMeeting: false,
  authorizing: false,
  updatingContext: false,
})

const { state, onChange } = ZoomAppStore

onChange('configResponse', async (cr) => {
  state.inMeeting = cr && cr.runningContext === 'inMeeting'

  if (state.inMeeting) {
    state.meetingInformation = await getSDKMeetingInformation()
  } else {
    state.meetingInformation = null
  }
})

let authorizingTimerId: number
onChange('authorizing', (authorizing) => {
  logWithBadge('zoomSdk', 'authorizing', authorizing)

  // Always clear the timeout, we may set a new one anyway
  if (authorizingTimerId) {
    window.clearTimeout(authorizingTimerId)
  }

  if (authorizing) {
    authorizingTimerId = window.setTimeout(() => (state.authorizing = false), 5000)
  }
})

let updatingContextId: number
onChange('updatingContext', (updatingContext) => {
  logWithBadge('zoomSdk', 'updatingContext', updatingContext)

  // Always clear the timeout, we may set a new one anyway
  if (updatingContextId) {
    window.clearTimeout(updatingContextId)
  }

  if (updatingContext) {
    updatingContextId = window.setTimeout(() => (state.updatingContext = false), 5000)
  }
})
